
/**
 * 调用摇一摇的方法
 * @since 1.0.0
 * 
 * @example
 * 
 * shakeOneShake().then(res => {})
 */
function shakeOneShake() {
    return new Promise((resolve) => {
        window.WebViewJavascriptBridge.registerHandler('shakeOneShake', function(data, responseCallback) {
            var responseData = {
                status: 0
            }
            responseCallback(responseData)
            resolve(data)
        })
    })
}

export default shakeOneShake